import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import MobileNav from './components/MobileNav';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import NewJob from './pages/NewJob';
import JobDetail from './pages/JobDetail';
import Schedule from './pages/Schedule';
import Timesheets from './pages/Timesheets';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import PendingPage from './pages/PendingPage';
import ZohoCallback from './pages/ZohoCallback';

function App() {
  const { user, isPending, loading } = useAuth();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
        <p>Loading FieldSync...</p>
      </div>
    );
  }

  // Pending users ONLY see the pending page, nothing else
  if (user && isPending) {
    return (
      <div className="app">
        <PendingPage />
      </div>
    );
  }

  return (
    <div className="app">
      {!online && (
        <div className="offline-banner no-print">
          ⚠️ You are offline. Some features may be limited.
        </div>
      )}

      <main>
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/" replace /> : <Login />}
          />
          <Route
            path="/"
            element={user ? <Dashboard /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/jobs"
            element={user ? <Jobs /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/jobs/location/:location"
            element={user ? <Jobs /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/jobs/worker/:workerId"
            element={user ? <Jobs /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/jobs/new"
            element={user ? <NewJob /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/jobs/:id"
            element={user ? <JobDetail /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/schedule"
            element={user ? <Schedule /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/timesheets"
            element={user ? <Timesheets /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/profile"
            element={user ? <Profile /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/admin"
            element={user ? <Admin /> : <Navigate to="/login" replace />}
          />
          <Route path="/zoho-callback" element={<ZohoCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {user && !isPending && <MobileNav />}
    </div>
  );
}

export default App;
